import { BaseMenu } from "./base-menu";

export class TypeMenu extends BaseMenu {
    category: boolean = false;
    type: boolean = false;
}
